/* ==========================================================
   Width x Height (sqft) Calculator  —  Dragonfly Boxed Layout
   ----------------------------------------------------------
   - Price = the ACTUAL variant price, so volume discounts on
     larger sizes (e.g. 8x8 = $98, 10x8 = $128) are reflected.
   - Allowed range is derived from the variant grid: width is
     limited to the largest width that still offers the full
     height range (=> 8 ft), height up to its max (=> 50 ft).

   - 250 VARIANT LIMIT: Liquid embeds at most 250 variants, and
     /products/{handle}.js is capped at 250 as well. A product
     with more (Custom Vinyl Banners has 637) therefore loses
     its larger widths, which used to cap the calculator at 6 ft
     and made those sizes impossible to price or add to cart.
     The missing rows are stored on the product as a JSON
     metafield (custom.sqft_matrix) and rendered by the
     'sqft-variant-data' section as:
       { "o": ["WIDTH","HEIGHT"], "v": [[w, h, priceCents, variantId], ...] }
     We merge those rows in before deriving the ranges.
   ========================================================== */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function isNumeric(str) {
    return /^\d+(\.\d+)?$/.test(String(str).trim());
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur });
  }
  function log() {
    try { console.info.apply(console, ['[sqft]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var WIDTH_RE = /^width\b/i;
  var HEIGHT_RE = /^height\b/i;

  function optionIndex(product, re) {
    for (var i = 0; i < product.options.length; i++) {
      var name = product.options[i];
      if (typeof name === 'object' && name !== null) name = name.name;
      if (re.test(String(name))) return i;
    }
    return -1;
  }

  // Merge the rows Liquid could not embed (see header comment).
  function mergeExtraVariants(product) {
    var el = document.querySelector('[data-sqft-extra-variants]');
    if (!el) return 0;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return 0; }
    if (!data || !data.v || !data.v.length) return 0;

    var wIdx = optionIndex(product, WIDTH_RE);
    var hIdx = optionIndex(product, HEIGHT_RE);
    if (wIdx < 0 || hIdx < 0) return 0;

    var wKey = 'option' + (wIdx + 1);
    var hKey = 'option' + (hIdx + 1);

    var seen = {};
    product.variants.forEach(function (v) {
      seen[String(v[wKey]) + 'x' + String(v[hKey])] = true;
    });

    var added = 0;
    data.v.forEach(function (row) {
      var w = row[0], h = row[1], price = row[2], id = row[3];
      if (seen[String(w) + 'x' + String(h)]) return;
      var variant = { id: id, price: price, available: true };
      variant[wKey] = String(w);
      variant[hKey] = String(h);
      product.variants.push(variant);
      added++;
    });
    return added;
  }

  function initCalculator(root) {
    var dataEl = root.querySelector('[data-sqft-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!product.options || product.options.length < 2) return;
    if (!product.variants) product.variants = [];

    var embedded = product.variants.length;
    var added = mergeExtraVariants(product);
    log('variants \u2014 embedded:', embedded, '| added from metafield:', added, '| total:', product.variants.length);

    build(root, dataEl, product);
  }

  function build(root, dataEl, product) {
    if (root.querySelector('.sqft-calc')) return;

    var widthOpt = null, heightOpt = null;
    product.options.forEach(function (name, idx) {
      if (typeof name === 'object' && name !== null) name = name.name;
      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (idx + 1)];
        if (val != null && values.indexOf(val) === -1) values.push(val);
      });
      if (values.length < 2 || !values.every(isNumeric)) return;
      var sorted = values.map(Number).sort(function (a, b) { return a - b; });
      if (WIDTH_RE.test(name)) widthOpt = { idx: idx, name: name, values: sorted };
      if (HEIGHT_RE.test(name)) heightOpt = { idx: idx, name: name, values: sorted };
    });
    if (!widthOpt || !heightOpt) return;

    function optW(v) { return Number(v['option' + (widthOpt.idx + 1)]); }
    function optH(v) { return Number(v['option' + (heightOpt.idx + 1)]); }

    // Overall max height, and the max width that still offers that full
    // height (the single-panel roll limit). Derived, so it auto-adjusts
    // if the variant grid changes.
    var heightMax = heightOpt.values[heightOpt.values.length - 1];
    var widthMax = 0;
    product.variants.forEach(function (v) {
      if (optH(v) === heightMax && optW(v) > widthMax) widthMax = optW(v);
    });
    if (!widthMax) widthMax = widthOpt.values[widthOpt.values.length - 1];
    var widthMin = widthOpt.values[0];
    var heightMin = heightOpt.values[0];

    log('derived range \u2014 width', widthMin + '-' + widthMax, '| height', heightMin + '-' + heightMax);

    var widthValues = widthOpt.values.filter(function (v) { return v >= widthMin && v <= widthMax; });
    var heightValues = heightOpt.values.filter(function (v) { return v >= heightMin && v <= heightMax; });

    // Base per-sqft rate (smallest size) — used only to detect discounts.
    var baseRateCents = (function () {
      var r = null;
      product.variants.forEach(function (v) {
        var a = optW(v) * optH(v);
        if (a > 0 && v.price != null) { var rate = v.price / a; if (r == null || rate > r) r = rate; }
      });
      return r;
    })();

    // Hide the underlying Width / Height selectors (rendered as siblings).
    var scope = root.closest('.product-options') || root.parentElement || document;
    function optionSelector(name) {
      var sels = scope.querySelectorAll('.option-selector[data-option]');
      for (var i = 0; i < sels.length; i++) {
        if (sels[i].getAttribute('data-option') === name) return sels[i];
      }
      return null;
    }
    var widthSel = optionSelector(widthOpt.name);
    var heightSel = optionSelector(heightOpt.name);
    [widthSel, heightSel].forEach(function (el) { if (el) el.style.display = 'none'; });

    var wrap = document.createElement('div');
    wrap.className = 'sqft-calc';
    wrap.innerHTML =
      '<div class="sqft-calc__row">' +
        '<div class="sqft-calc__field">' +
          '<label>' + widthOpt.name + ' (' + widthMin + '\u2013' + widthMax + ' ft)</label>' +
          '<input type="number" min="' + widthMin + '" max="' + widthMax + '" step="1" placeholder="0" class="sqft-calc__input" data-sqft-width>' +
        '</div>' +
        '<div class="sqft-calc__field">' +
          '<label>' + heightOpt.name + ' (' + heightMin + '\u2013' + heightMax + ' ft)</label>' +
          '<input type="number" min="' + heightMin + '" max="' + heightMax + '" step="1" placeholder="0" class="sqft-calc__input" data-sqft-height>' +
        '</div>' +
      '</div>' +
      '<div class="sqft-calc__hint">Max width ' + widthMax + ' ft \u00b7 max height ' + heightMax + ' ft. For a longer banner, enter the longer side as ' + heightOpt.name + '.</div>' +
      '<div class="sqft-calc__summary" data-sqft-summary></div>';
    root.insertBefore(wrap, dataEl.nextSibling);

    var widthInput = wrap.querySelector('[data-sqft-width]');
    var heightInput = wrap.querySelector('[data-sqft-height]');
    var summary = wrap.querySelector('[data-sqft-summary]');

    function snap(values, target) {
      if (target <= values[0]) return values[0];
      if (target >= values[values.length - 1]) return values[values.length - 1];
      var best = values[0], bd = Infinity;
      for (var i = 0; i < values.length; i++) {
        var d = Math.abs(values[i] - target);
        if (d < bd) { bd = d; best = values[i]; }
      }
      return best;
    }
    function findVariant(w, h) {
      return product.variants.find(function (v) { return optW(v) === w && optH(v) === h; });
    }
    function driveDropdown(sel, value) {
      if (!sel) return;
      var type = sel.getAttribute('data-selector-type');
      if (type === 'dropdown') {
        var opts = sel.querySelectorAll('.custom-select__option');
        for (var i = 0; i < opts.length; i++) {
          if (String(opts[i].getAttribute('data-value')) === String(value)) { opts[i].click(); break; }
        }
      } else {
        var radios = sel.querySelectorAll('input[type="radio"]');
        radios.forEach(function (r) {
          if (String(r.value) === String(value)) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
            r.dispatchEvent(new Event('click', { bubbles: true }));
          }
        });
      }
    }
    function setCartVariant(variant) {
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (inp) {
        inp.value = variant.id;
      });
    }

    function render() {
      var wRaw = parseFloat(widthInput.value) || 0;
      var hRaw = parseFloat(heightInput.value) || 0;

      if (wRaw > 0 && hRaw > 0) {
        var w = snap(widthValues, wRaw);
        var h = snap(heightValues, hRaw);
        var area = w * h;
        var variant = findVariant(w, h);
        var priceCents = variant ? variant.price
                        : (baseRateCents != null ? Math.round(area * baseRateCents) : null);

        var notes = '';
        if (wRaw > widthMax) notes += '<div class="sqft-calc__rounded">Maximum width is ' + widthMax + ' ft \u2014 enter the longer side as ' + heightOpt.name + '.</div>';
        if (hRaw > heightMax) notes += '<div class="sqft-calc__rounded">Maximum height is ' + heightMax + ' ft.</div>';
        if ((w !== wRaw && wRaw <= widthMax) || (h !== hRaw && hRaw <= heightMax)) {
          notes += '<div class="sqft-calc__rounded">Rounded to ' + w + '\' x ' + h + '\'</div>';
        }
        var discounted = (variant && baseRateCents != null && variant.price < Math.round(area * baseRateCents) - 1);
        if (discounted) notes += '<div class="sqft-calc__rounded">Volume discount applied</div>';

        summary.innerHTML =
          '<div class="sqft-calc__area">' + w + '\' x ' + h + '\' = ' + area + ' ft&sup2;</div>' +
          (priceCents != null ? '<div class="sqft-calc__price">' + money(priceCents) + '</div>' : '') +
          notes;

        if (variant) {
          driveDropdown(widthSel, w);
          driveDropdown(heightSel, h);
          setCartVariant(variant);
        }
        return;
      }

      // 0 x 0 (or incomplete): keep the calculator visible.
      summary.innerHTML =
        '<div class="sqft-calc__area">' + (wRaw || 0) + '\' x ' + (hRaw || 0) + '\' = ' + ((wRaw || 0) * (hRaw || 0)) + ' ft&sup2;</div>';
    }

    widthInput.addEventListener('input', render);
    heightInput.addEventListener('input', render);
    render();
  }

  ready(function () {
    document.querySelectorAll('[data-sqft-calculator]').forEach(initCalculator);
  });
})();
